import { labeled, Tabs as Tabs_1, detailsSection, clampIndex, Icon_Path_fertilizer, Icon_Path_item, labeledHidden, xpFloat, xp as xp_3, percent2, upperFirstChar, pluralizeTo, Icon_productQuality, Icon_processor, Icon_seed, Icon_itemIdQuality, Icon_vendor, gold as gold_2, gold2, pluralize, round2, Icon_crop, Icon_fertilizer, ofOption, Icon_season, Icon_NoText_itemId, Icon_regrowStage, Icon_NoText_item, Icon_growthStage, Icon_warning } from "./Prelude.js";
import { Game_seedItemSellPrice, Location, Game_growthTimeAndStages, Game_cropIsInSeason } from "../Model/Game.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { comparePrimitives, structuralHash, numberHash, compare, round, int32ToString, equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { toArray as toArray_1, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { AppMode_$reflection, OptimizationObjective_$reflection, AppMode, OpenDetails as OpenDetails_1, Fertilizer_Opt_displayName, RankItem_$reflection, Result_isOk, Result_defaultValue, Option_ofResult, RankMetricModule_unit, RankMetric, TimeNormalization_$reflection, RankMetric_$reflection, TimeNormalization, TimeNormalizationModule_unit, SeedStrategy } from "../Types.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { mapIndexed as mapIndexed_1, empty as empty_1, tail as tail_1, head, isEmpty, toArray as toArray_2, ofArrayWithTail, singleton as singleton_1, cons, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { sortBy, maxBy, unzip, fold, reverse, singleton as singleton_2, collect, choose, zip, chunkBySize, map as map_1, tryHead, tryPick, append as append_1, foldBack, last, item as item_2, setItem, insertAt, sum, fill, mapIndexed, concat, tail } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { CropModule_name, Crop_$reflection, CropModule_items, CropModule_seedItem, CropModule_regrows, Date$, CropModule_mainItem, CropModule_seed, DateModule_totalDays, DateModule_daySpan, Growth_daysNeededFor, Crop } from "../Model/Crops.js";
import { tryGetValue, getItemFromDict } from "../fable_modules/fable-library-js.4.29.0/MapUtil.js";
import { unwrap, defaultArg, some, map, toArray, value as value_43 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { max as max_1 } from "../fable_modules/fable-library-js.4.29.0/Double.js";
import { Enum_bitSetOrder, Option_defaultOrMap } from "../Model/Prelude.js";
import { SeasonModule_span } from "../Model/Crops.js";
import { Ranker_rankValue, Selected_fertilizersOpt, Selected_inSeasonCrops, Optimizer_xpSummary, CropXpSummaryModule_totalXp, Ranker_xpSummary, Optimizer_profitSummary, Ranker_profitSummary, ProfitSummaryModule_investmentAndRoi, bestGrowthSpan } from "../Query.js";
import { createWorker, FertilizerDateSpan } from "../Optimizer.js";
import { join, printf, toText } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { FertilizerModule_Opt_name, Fertilizer_$reflection, Qualities_indexed } from "../Model/Skills.js";
import { ProcessorModule_seedMakerExpectedQuantity } from "../Model/Items.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.4.29.0/Int32.js";
import { getUnionCases, makeUnion, record_type, union_type, enum_type, int32_type, float64_type, tuple_type, string_type, uint32_type, option_type, array_type, getCaseName } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Record, FSharpRef } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { collapsibleHeaderAndBodies } from "./Table.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.29.0/Result.js";
import { search, options } from "./Select.js";
import { Values_fontPx } from "./Style.js";
import { StateMessage, UIMessage, RankerMessage } from "../Update.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ResponsiveContainer, BarChart, Brush, XAxis, YAxis, Bar, Tooltip } from "recharts";
import { objectHas } from "../fable_modules/Feliz.Recharts.4.3.0/Interop.fs.js";
import { Array_groupBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { checkbox } from "./Input.js";
import { Common_lazyView, Common_lazyView3 } from "../fable_modules/Fable.Elmish.React.5.0.0/common.fs.js";
import { FSharpChoice$2 } from "../fable_modules/fable-library-js.4.29.0/Choice.js";
import { Crops_sortKey } from "./Settings.js";

export function noHarvestsMessage(settings, crop) {
    return Icon_warning(Game_cropIsInSeason(settings.Game, crop) ? "No harvests possible." : "Crop is not in season.");
}

export function invalidReasons(settings, crop, reasons) {
    let elems;
    return createElement("ul", createObj(ofArray([["className", "messages"], (elems = toList(delay(() => append(((reasons & 1) !== 0) ? singleton(createElement("li", {
        children: [noHarvestsMessage(settings, crop)],
    })) : empty(), delay(() => append(((reasons & 4) !== 0) ? singleton(createElement("li", {
        children: [Icon_warning(equals(settings.Profit.SeedStrategy, new SeedStrategy(0, [])) ? "No seed price." : "No seed source.")],
    })) : empty(), delay(() => append(((reasons & 2) !== 0) ? singleton(createElement("li", {
        children: [Icon_warning("No fertilizer price.")],
    })) : empty(), delay(() => (((reasons & 8) !== 0) ? singleton(createElement("li", {
        children: [Icon_warning("No investment.")],
    })) : empty()))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function GrowthCalendar_repeatCons(n_mut, items_mut, list_mut) {
    GrowthCalendar_repeatCons:
    while (true) {
        const n = n_mut, items = items_mut, list = list_mut;
        if (n === 0) {
            return list;
        }
        else {
            n_mut = (n - 1);
            items_mut = items;
            list_mut = cons(items, list);
            continue GrowthCalendar_repeatCons;
        }
        break;
    }
}

function GrowthCalendar_nameItem(_arg) {
    if (_arg.tag === 1) {
        return _arg.fields[0].Seed * 1;
    }
    else {
        return _arg.fields[0].Item;
    }
}

export function GrowthCalendar_stageImage(seed, item, stage) {
    return createElement("div", {
        children: [Icon_growthStage(seed, item, stage)],
    });
}

export function GrowthCalendar_stageImages(seed, item, stages) {
    return tail(concat(mapIndexed((i, stage) => fill(new Array(~~stage), 0, ~~stage, GrowthCalendar_stageImage(seed, item, i)), stages)));
}

function GrowthCalendar_regrowCropCalendarDays(data, settings, days, fertilizer, stageList, season, crop, harvests) {
    const totalDays = sum(days.slice(season + 1, days.length), {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
    const patternInput = Game_growthTimeAndStages(settings.Game, fertilizer, new Crop(0, [crop]));
    const usedDays = Growth_daysNeededFor(crop.RegrowTime, patternInput[1], harvests);
    const item = getItemFromDict(data.Items.fields[0], crop.Item);
    const stageImages = GrowthCalendar_stageImages(crop.Seed, item, patternInput[0]);
    const harvestItem = createElement("div", {
        children: [Icon_NoText_item(item)],
    });
    let firstHarvest;
    const array_1 = stageImages;
    firstHarvest = insertAt(array_1.length, harvestItem, array_1);
    const regrow = fill(new Array(~~value_43(crop.RegrowTime)), 0, ~~value_43(crop.RegrowTime), createElement("div", {
        children: [Icon_regrowStage(crop.Seed, item)],
    }));
    setItem(regrow, regrow.length - 1, harvestItem);
    const filler = max_1(0, ~~totalDays - ~~usedDays) | 0;
    const stageList_2 = GrowthCalendar_repeatCons(harvests - 1, regrow, cons(fill(new Array(filler), 0, filler, createElement("div", {})), stageList));
    return [season, ((totalDays + item_2(season, days)) - usedDays) - (filler >>> 0), cons(firstHarvest, stageList_2)];
}

function GrowthCalendar_fromDateSpan(data, settings, single, span) {
    let array_5;
    const stageList = singleton_1(fill(new Array(~~(28 - span.EndDate.Day)), 0, ~~(28 - span.EndDate.Day), createElement("div", {
        className: "disabled",
    })));
    const days = (!single && equals(settings.Game.Location, new Location(0, []))) ? DateModule_daySpan(span.StartDate, span.EndDate) : (new Uint32Array([DateModule_totalDays(span.StartDate, span.EndDate)]));
    const patternInput = Option_defaultOrMap([days.length - 1, last(days), stageList], (tupledArg) => GrowthCalendar_regrowCropCalendarDays(data, settings, days, span.Fertilizer, stageList, tupledArg[0], tupledArg[1], tupledArg[2]), span.RegrowCrop);
    const patternInput_2 = foldBack((tupledArg_1, tupledArg_2) => {
        const crop_1 = tupledArg_1[0];
        const harvests_1 = tupledArg_1[1];
        const season_2 = tupledArg_2[0] | 0;
        const remainingDays_1 = tupledArg_2[1] | 0;
        const stageList_2 = tupledArg_2[2];
        const seed = CropModule_seed(crop_1);
        const item = getItemFromDict(data.Items.fields[0], GrowthCalendar_nameItem(crop_1));
        const patternInput_1 = Game_growthTimeAndStages(settings.Game, span.Fertilizer, crop_1);
        const time = patternInput_1[1];
        const stages = patternInput_1[0];
        const stageImages = GrowthCalendar_stageImages(seed, item, stages);
        const harvestItem = [createElement("div", {
            children: [Icon_NoText_itemId(data, CropModule_mainItem(crop_1))],
        })];
        if (tupledArg_1[2]) {
            const filler = max_1(0, remainingDays_1 - ~~time) | 0;
            const season_3 = (season_2 - 1) | 0;
            return [season_3, ((remainingDays_1 + ~~item_2(season_3, days)) - ~~time) - filler, ofArrayWithTail([stageImages, fill(new Array(filler), 0, filler, GrowthCalendar_stageImage(seed, item, stages.length)), harvestItem], stageList_2)];
        }
        else {
            return [season_2, remainingDays_1 - ~~Growth_daysNeededFor(undefined, time, harvests_1), GrowthCalendar_repeatCons(harvests_1, append_1(stageImages, harvestItem), stageList_2)];
        }
    }, span.CropHarvests, [patternInput[0], ~~patternInput[1], patternInput[2]]);
    const days_2 = patternInput_2[1] | 0;
    const firstStage = toArray(map((crop_4) => GrowthCalendar_stageImage(CropModule_seed(crop_4), getItemFromDict(data.Items.fields[0], GrowthCalendar_nameItem(crop_4)), 0), tryPick((x) => x, [map((tupledArg_3) => tupledArg_3[0], tryHead(span.CropHarvests)), map((tupledArg_4) => (new Crop(0, [tupledArg_4[1]])), span.RegrowCrop)])));
    return map_1((tupledArg_5) => {
        let elems_2, elems;
        return createElement("div", createObj(ofArray([["className", "calendar-season"], (elems_2 = [createElement("div", createObj(ofArray([["className", "calendar-header"], (elems = [Icon_season(tupledArg_5[0]), ofOption(Icon_fertilizer, span.Fertilizer)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", {
            className: "calendar-days",
            children: reactApi.Children.toArray(Array.from(tupledArg_5[1])),
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }, (array_5 = chunkBySize(~~28, concat(ofArrayWithTail([fill(new Array(~~(span.StartDate.Day - 1)), 0, ~~(span.StartDate.Day - 1), createElement("div", {
        className: "disabled",
    })), fill(new Array(days_2 - 1), 0, days_2 - 1, createElement("div", {})), firstStage], patternInput_2[2]))), zip(SeasonModule_span(span.StartDate.Season, span.EndDate.Season), array_5)));
}

export function GrowthCalendar_optimizer(data, settings, dateSpan) {
    return GrowthCalendar_fromDateSpan(data, settings, false, dateSpan);
}

export function GrowthCalendar_ranker(data, settings, fertilizer, crop) {
    let elems;
    const matchValue = bestGrowthSpan(settings.Game, fertilizer, crop);
    if (matchValue != null) {
        const span = matchValue;
        const patternInput = (crop.tag === 0) ? ((crop.fields[0].RegrowTime != null) ? [[], [0, crop.fields[0], span.Harvests]] : [[[crop, span.Harvests, false]], undefined]) : [[[crop, span.Harvests, false]], undefined];
        return createElement("div", createObj(ofArray([["className", "calendar"], (elems = GrowthCalendar_fromDateSpan(data, settings, true, new FertilizerDateSpan(new Date$(span.StartSeason, (span.StartSeason === settings.Game.StartDate.Season) ? settings.Game.StartDate.Day : 1), new Date$(span.EndSeason, (span.EndSeason === settings.Game.EndDate.Season) ? settings.Game.EndDate.Day : 28), fertilizer, patternInput[0], patternInput[1])), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return noHarvestsMessage(settings, crop);
    }
}

function fertilizerAndCrop(data, fertilizer, crop) {
    const xs_1 = [Icon_crop(data, crop), ofOption((fertilizer_1) => {
        const xs = [" with ", Icon_fertilizer(fertilizer_1)];
        return react.createElement(react.Fragment, {}, ...xs);
    }, fertilizer)];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

function SummaryTable_toPrecision(value) {
    const rounded = round2(value);
    if (rounded === 0) {
        return toText(printf("%.2e"))(value);
    }
    else {
        return rounded.toString();
    }
}

function SummaryTable_formatNormalizationDivisor(timeNorm, normDivisor) {
    return `${round2(normDivisor)} ${pluralize(TimeNormalizationModule_unit(timeNorm))}`;
}

function SummaryTable_formatNormalizedValue(format, normDivisor, value) {
    return Option_defaultOrMap("???", (value_1) => format(value_1 / normDivisor), value);
}

function SummaryTable_rowCells(itemCell, unitValue, quantity, value, seeds) {
    return [createElement("th", {
        scope: "row",
        children: itemCell,
    }), createElement("td", {
        children: [unitValue],
    }), createElement("td", {
        children: [quantity],
    }), createElement("td", {
        children: [value],
    }), createElement("td", {
        children: [seeds],
    })];
}

function SummaryTable_significantRow(seeds, itemCell, price, quantity) {
    const profit = Option_defaultOrMap(0, (tupledArg) => round2((tupledArg[0] * quantity) * (tupledArg[1] ? -1 : 1)), price);
    if ((profit === 0) && (round2(quantity) === 0)) {
        return undefined;
    }
    else {
        const profit_1 = (price == null) ? defaultOf() : gold2(profit);
        const price_2 = ofOption((arg_1) => gold_2(arg_1[0]), price);
        const quantity_1 = (quantity === 0) ? defaultOf() : SummaryTable_toPrecision(quantity);
        return SummaryTable_rowCells(itemCell, price_2, quantity_1, profit_1, seeds ? quantity_1 : defaultOf());
    }
}

function SummaryTable_seedRow(itemCell, quantity) {
    return SummaryTable_significantRow(true, itemCell, undefined, quantity);
}

function SummaryTable_profitRow(itemCell, price_, price__1, quantity) {
    return SummaryTable_significantRow(false, itemCell, [price_, price__1], quantity);
}

function SummaryTable_unknownProfitRow(seeds, itemCell, quantity) {
    if (quantity === 0) {
        return undefined;
    }
    else {
        const quantity_1 = SummaryTable_toPrecision(quantity);
        return SummaryTable_rowCells(itemCell, "???", quantity_1, "???", seeds ? quantity_1 : defaultOf());
    }
}

function SummaryTable_boughtRow(seeds, priceAndVendor, quantity, icon) {
    let children;
    if (priceAndVendor == null) {
        return SummaryTable_unknownProfitRow(seeds, createElement("span", {
            children: reactApi.Children.toArray([icon, " from ???"]),
        }), quantity);
    }
    else {
        const vendor = priceAndVendor[0];
        const price = priceAndVendor[1];
        return SummaryTable_significantRow(seeds, (children = toList(delay(() => append(singleton(icon), delay(() => {
            const matchValue = vendor;
            return (matchValue.tag === 1) ? singleton(" (Custom)") : append(singleton(" from "), delay(() => singleton(Icon_vendor(matchValue.fields[0]))));
        })))), createElement("span", {
            children: reactApi.Children.toArray(Array.from(children)),
        })), [price, true], quantity);
    }
}

function SummaryTable_itemCellWithInputs(data, itemCell, inputs) {
    let elems, children_4;
    return createElement("details", createObj(ofArray([["className", "input-items"], (elems = [createElement("summary", {
        children: reactApi.Children.toArray([itemCell]),
    }), (children_4 = map_1((tupledArg) => {
        const _arg = tupledArg[0];
        const quantity_1 = round2(tupledArg[1]);
        if (quantity_1 === 0) {
            return defaultOf();
        }
        else {
            const children_2 = ofArray([Icon_itemIdQuality(data, _arg[0], _arg[1]), ` x ${quantity_1}`]);
            return createElement("li", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            });
        }
    }, inputs), createElement("ul", {
        children: reactApi.Children.toArray(Array.from(children_4)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function SummaryTable_fertilizerBoughtRow(replacement, fertilizer, price, quantity) {
    let xs;
    let matchResult, fertilizer_1, price_1;
    if (fertilizer != null) {
        if (price != null) {
            matchResult = 0;
            fertilizer_1 = fertilizer;
            price_1 = value_43(price);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return SummaryTable_boughtRow(false, price_1, quantity, (xs = toList(delay(() => append(replacement ? singleton("Replacement ") : empty(), delay(() => singleton(Icon_fertilizer(fertilizer_1)))))), react.createElement(react.Fragment, {}, ...xs)));
        default:
            return undefined;
    }
}

function SummaryTable_harvestedSeedsRows(data, item, quantities) {
    return choose((tupledArg) => SummaryTable_seedRow(Icon_itemIdQuality(data, item, tupledArg[0]), tupledArg[1]), Qualities_indexed(quantities));
}

function SummaryTable_seedMakerRows(data, crop, item, quantities) {
    let inputs, children;
    const seed = CropModule_seed(crop);
    return toArray(SummaryTable_seedRow((inputs = map_1((tupledArg) => [[item, tupledArg[0]], tupledArg[1]], Qualities_indexed(quantities)), SummaryTable_itemCellWithInputs(data, (children = ofArray([Icon_seed(data, seed), " from ", Icon_processor("Seed Maker")]), createElement("span", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), inputs)), ProcessorModule_seedMakerExpectedQuantity(seed) * sum(quantities.fields[0], {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    })));
}

function SummaryTable_forageSeedsRows(data, settings, items, seed, quantitySold, quantityUsed) {
    if ((quantitySold === 0) && (quantityUsed === 0)) {
        return new Array(0);
    }
    else {
        const inputsCell = (quantity) => {
            let children;
            const quantity_1 = quantity / 10;
            const inputs = map_1((item) => [[item, 0], quantity_1], items);
            return SummaryTable_itemCellWithInputs(data, (children = ofArray([Icon_seed(data, seed), " from Crafting"]), createElement("span", {
                children: reactApi.Children.toArray(Array.from(children)),
            })), inputs);
        };
        const price = Game_seedItemSellPrice(data, settings.Game, seed);
        return collect(toArray, [SummaryTable_seedRow(inputsCell(quantityUsed), quantityUsed), SummaryTable_profitRow(inputsCell(quantitySold), price, false, quantitySold)]);
    }
}

function SummaryTable_unsoldItemRow(data, item, quantities) {
    return choose((tupledArg) => {
        const quantity = tupledArg[1];
        if (quantity === 0) {
            return undefined;
        }
        else {
            const quantity_1 = SummaryTable_toPrecision(quantity);
            return SummaryTable_rowCells(Icon_itemIdQuality(data, item, tupledArg[0]), "???", quantity_1, defaultOf(), defaultOf());
        }
    }, Qualities_indexed(quantities));
}

function SummaryTable_soldItemRow(data, summary) {
    let xs;
    return SummaryTable_profitRow((xs = toList(delay(() => append(singleton(Icon_itemIdQuality(data, summary.Item, summary.Quality)), delay(() => (summary.Custom ? singleton(" (Custom)") : empty()))))), react.createElement(react.Fragment, {}, ...xs)), summary.Price, false, summary.Quantity);
}

function SummaryTable_soldProductRow(data, summary) {
    return SummaryTable_profitRow(SummaryTable_itemCellWithInputs(data, Icon_productQuality(data, summary.Product, summary.Quality), summary.ConsumedItemQuantities), summary.Price, false, summary.Quantity);
}

function SummaryTable_cropProfitSummaryRows(data, settings, fertilizer, fertilizerPrice, summary) {
    const crop = summary.Crop;
    const seed = CropModule_seed(crop);
    return map_1((xs) => react.createElement(react.Fragment, {}, ...xs), concat(toArray_1(delay(() => append(singleton(toArray(SummaryTable_boughtRow(true, summary.SeedPrice, summary.SeedsBought, Icon_seed(data, seed)))), delay(() => {
        let seeds;
        return append(!equals(settings.Profit.SeedStrategy, new SeedStrategy(2, [])) ? ((seeds = (op_UnaryNegation_Int32(~~(CropModule_regrows(crop) ? 1 : summary.Harvests)) | 0), singleton([SummaryTable_rowCells(`${summary.Harvests} ${pluralizeTo(summary.Harvests, "harvest")}`, defaultOf(), defaultOf(), defaultOf(), seeds)]))) : empty(), delay(() => append(singleton(collect((tupledArg) => {
            const item = tupledArg[0];
            const quantities = tupledArg[1];
            if (item === CropModule_seedItem(crop)) {
                return SummaryTable_harvestedSeedsRows(data, item, quantities);
            }
            else if (item === CropModule_mainItem(crop)) {
                return SummaryTable_seedMakerRows(data, crop, item, quantities);
            }
            else {
                return new Array(0);
            }
        }, summary.SeedsUsed)), delay(() => append(singleton(SummaryTable_forageSeedsRows(data, settings, CropModule_items(crop), seed, summary.ForageSeedsSold, summary.ForageSeedsUsed)), delay(() => append(singleton(collect((tupledArg_1) => SummaryTable_unsoldItemRow(data, tupledArg_1[0], tupledArg_1[1]), summary.UnsoldItems)), delay(() => append(singleton(choose((summary_1) => SummaryTable_soldItemRow(data, summary_1), summary.SoldItems)), delay(() => append(singleton(choose((summary_2) => SummaryTable_soldProductRow(data, summary_2), summary.SoldProducts)), delay(() => singleton(toArray(SummaryTable_fertilizerBoughtRow(true, fertilizer, fertilizerPrice, summary.ReplacedFertilizer)))))))))))))));
    }))))));
}

function SummaryTable_footerProfitRowCells(itemCell, profit, seeds) {
    return SummaryTable_rowCells(itemCell, defaultOf(), defaultOf(), profit, seeds);
}

function SummaryTable_totalRowCells(totalFormat, total, seeds) {
    return SummaryTable_footerProfitRowCells("Total", Option_defaultOrMap("???", totalFormat, total), seeds);
}

function SummaryTable_thColWith(cell) {
    return createElement("th", {
        scope: "col",
        children: cell,
    });
}

const SummaryTable_thCol = SummaryTable_thColWith;

function SummaryTable_profitHeaderCells(itemCell, seeds) {
    const xs = [SummaryTable_thCol(itemCell), SummaryTable_thCol("Price"), SummaryTable_thCol("Quantity"), SummaryTable_thCol("Profit"), SummaryTable_thColWith(seeds ? "Seeds" : defaultOf())];
    return react.createElement(react.Fragment, {}, ...xs);
}

function SummaryTable_profitHeader(itemCell, seeds) {
    let children;
    const children_2 = singleton_1((children = singleton_1(SummaryTable_profitHeaderCells(itemCell, seeds)), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    })));
    return createElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    });
}

function SummaryTable_profitFooter(timeNorm, normDivisor, profit, seeds) {
    const children_6 = toList(delay(() => {
        let children;
        return append(singleton((children = SummaryTable_totalRowCells(gold2, profit, seeds), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))), delay(() => {
            let children_2;
            return (equals(timeNorm, new TimeNormalization(0, [])) ? true : (normDivisor === 1)) ? singleton(defaultOf()) : append(singleton((children_2 = SummaryTable_footerProfitRowCells(upperFirstChar(pluralize(TimeNormalizationModule_unit(timeNorm))), `${SummaryTable_formatNormalizationDivisor(timeNorm, normDivisor)}`, defaultOf()), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            }))), delay(() => {
                let children_4, str_3;
                return singleton((children_4 = SummaryTable_footerProfitRowCells(`Total ${(str_3 = getCaseName(timeNorm), str_3.toLocaleLowerCase())}`, SummaryTable_formatNormalizedValue(gold2, normDivisor, profit), defaultOf()), createElement("tr", {
                    children: reactApi.Children.toArray(Array.from(children_4)),
                })));
            }));
        }));
    }));
    return createElement("tfoot", {
        children: reactApi.Children.toArray(Array.from(children_6)),
    });
}

function SummaryTable_rankerProfitSummary(data, settings, timeNorm, profitSummary) {
    const children_8 = toList(delay(() => append(singleton(SummaryTable_profitHeader("Item", !equals(settings.Profit.SeedStrategy, new SeedStrategy(2, [])))), delay(() => {
        let children_6;
        return append(singleton((children_6 = toList(delay(() => append(singleton(ofOption((children) => createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children)),
        }), SummaryTable_fertilizerBoughtRow(false, profitSummary.Fertilizer, profitSummary.FertilizerPrice, 1))), delay(() => map_1((arg) => {
            const children_3 = singleton_2(arg);
            return createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_3)),
            });
        }, SummaryTable_cropProfitSummaryRows(data, settings, profitSummary.Fertilizer, profitSummary.FertilizerPrice, item_2(0, profitSummary.CropSummaries))))))), createElement("tbody", {
            children: reactApi.Children.toArray(Array.from(children_6)),
        }))), delay(() => singleton(SummaryTable_profitFooter(timeNorm, profitSummary.TimeNormalization, profitSummary.NetProfit, equals(settings.Profit.SeedStrategy, new SeedStrategy(2, [])) ? defaultOf() : (0).toString()))));
    }))));
    return createElement("table", {
        children: reactApi.Children.toArray(Array.from(children_8)),
    });
}

function SummaryTable_optimizerProfitSummary(data, settings, total, summaries) {
    let children_2, children;
    const header = SummaryTable_profitHeaderCells("Crop / Item", !equals(settings.Profit.SeedStrategy, new SeedStrategy(2, [])));
    let getCount;
    const counts = new Map([]);
    getCount = ((seed) => {
        let count;
        let matchValue;
        let outArg = 0;
        matchValue = [tryGetValue(counts, seed, new FSharpRef(() => outArg, (v) => {
            outArg = (v | 0);
        })), outArg];
        count = (matchValue[0] ? matchValue[1] : 0);
        counts.set(seed, count + 1);
        return count | 0;
    });
    const children_4 = ofArray([collapsibleHeaderAndBodies(true, header, collect((profitSummary) => concat([toArray(map((row) => ["", react.createElement(react.Fragment, {}, ...row), []], SummaryTable_fertilizerBoughtRow(false, profitSummary.Fertilizer, profitSummary.FertilizerPrice, 1))), map_1((summary) => {
        let seed_1, count_1, xs_1;
        return [(seed_1 = CropModule_seed(summary.Crop), (count_1 = (getCount(seed_1) | 0), (seed_1.toString() + "@") + int32ToString(count_1))), (xs_1 = SummaryTable_rowCells(createElement("span", {
            children: [fertilizerAndCrop(data, profitSummary.Fertilizer, summary.Crop)],
        }), defaultOf(), summary.Harvests.toString(), ofOption(gold2, summary.NetProfit), defaultOf()), react.createElement(react.Fragment, {}, ...xs_1)), SummaryTable_cropProfitSummaryRows(data, settings, profitSummary.Fertilizer, profitSummary.FertilizerPrice, summary)];
    }, profitSummary.CropSummaries)]), summaries)), (children_2 = singleton_1((children = toList(delay(() => append(singleton(createElement("td", {})), delay(() => SummaryTable_totalRowCells(gold2, total, defaultOf()))))), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))), createElement("tfoot", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    }))]);
    return createElement("table", {
        children: reactApi.Children.toArray(Array.from(children_4)),
    });
}

function SummaryTable_keyValue(key, valueCell) {
    const xs = [createElement("dt", {
        children: [key],
    }), createElement("dd", {
        children: [valueCell],
    })];
    return react.createElement(react.Fragment, {}, ...xs);
}

function SummaryTable_normalizationRows(key, valueFormat, timeNorm, normDivisor, value) {
    let str_2;
    if (normDivisor === 1) {
        return defaultOf();
    }
    else {
        const xs = [SummaryTable_keyValue(upperFirstChar(pluralize(TimeNormalizationModule_unit(timeNorm))), SummaryTable_formatNormalizationDivisor(timeNorm, normDivisor)), SummaryTable_keyValue(`${key} ${(str_2 = getCaseName(timeNorm), str_2.toLocaleLowerCase())}`, SummaryTable_formatNormalizedValue(valueFormat, normDivisor, value))];
        return react.createElement(react.Fragment, {}, ...xs);
    }
}

function SummaryTable_roiSummary(settings, timeNorm, profitSummary) {
    const patternInput = ProfitSummaryModule_investmentAndRoi(equals(settings.Profit.SeedStrategy, new SeedStrategy(0, [])), profitSummary);
    const roi = patternInput[1];
    const children = ofArray([SummaryTable_keyValue("Investment", Option_defaultOrMap("???", gold_2, patternInput[0])), SummaryTable_keyValue("ROI", Option_defaultOrMap("???", percent2, roi)), SummaryTable_normalizationRows("ROI", percent2, timeNorm, profitSummary.TimeNormalization, roi)]);
    return createElement("dl", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function SummaryTable_tooltipBoughtRow(itemCell, price, quantity) {
    return ofOption((children) => createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    }), (price == null) ? SummaryTable_unknownProfitRow(false, itemCell, quantity) : SummaryTable_profitRow(itemCell, price[1], true, quantity));
}

function SummaryTable_tooltipProfitRow(itemCell, price, quantity) {
    return ofOption((children) => createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    }), SummaryTable_profitRow(itemCell, price, false, quantity));
}

function SummaryTable_profitTooltip(data, settings, timeNorm, profitSummary) {
    let children, xs, xs_1;
    const summary = item_2(0, profitSummary.CropSummaries);
    const seed = CropModule_seed(summary.Crop);
    const children_2 = ofArray([SummaryTable_profitHeader("Item", false), (children = ofArray([ofOption((price) => SummaryTable_tooltipBoughtRow(ofOption(Icon_fertilizer, profitSummary.Fertilizer), price, 1 + summary.ReplacedFertilizer), profitSummary.FertilizerPrice), SummaryTable_tooltipBoughtRow(Icon_seed(data, seed), summary.SeedPrice, summary.SeedsBought), SummaryTable_tooltipProfitRow(Icon_seed(data, seed), Game_seedItemSellPrice(data, settings.Game, seed), summary.ForageSeedsSold), (xs = map_1((summary_1) => SummaryTable_tooltipProfitRow(Icon_itemIdQuality(data, summary_1.Item, summary_1.Quality), summary_1.Price, summary_1.Quantity), summary.SoldItems), react.createElement(react.Fragment, {}, ...xs)), (xs_1 = map_1((summary_2) => SummaryTable_tooltipProfitRow(Icon_productQuality(data, summary_2.Product, summary_2.Quality), summary_2.Price, summary_2.Quantity), summary.SoldProducts), react.createElement(react.Fragment, {}, ...xs_1))]), createElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), SummaryTable_profitFooter(timeNorm, profitSummary.TimeNormalization, profitSummary.NetProfit, defaultOf())]);
    return createElement("table", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    });
}

function SummaryTable_mergeCropHarvests(dateSpan) {
    const regrowHarvests = map((tupledArg) => [new Crop(0, [tupledArg[1]]), tupledArg[2]], dateSpan.RegrowCrop);
    return reverse(toArray_2(fold((list, tupledArg_2) => {
        const crop_2 = tupledArg_2[0];
        const harvests_2 = tupledArg_2[1];
        let matchResult, lastCrop_1, lastHarvests_1, list_2, list_3;
        if (!isEmpty(list)) {
            if (CropModule_seed(head(list)[0]) === CropModule_seed(crop_2)) {
                matchResult = 0;
                lastCrop_1 = head(list)[0];
                lastHarvests_1 = head(list)[1];
                list_2 = tail_1(list);
            }
            else {
                matchResult = 1;
                list_3 = list;
            }
        }
        else {
            matchResult = 1;
            list_3 = list;
        }
        switch (matchResult) {
            case 0:
                return cons([crop_2, harvests_2 + lastHarvests_1], list_2);
            default:
                return cons([crop_2, harvests_2], list_3);
        }
    }, empty_1(), append_1(map_1((tupledArg_1) => [tupledArg_1[0], tupledArg_1[1]], dateSpan.CropHarvests), toArray(regrowHarvests)))));
}

export function SummaryTable_Profit_ranker(data, settings, timeNorm, fertilizer, crop) {
    const matchValue = Ranker_profitSummary(data, settings, timeNorm, fertilizer, crop);
    if (matchValue == null) {
        return noHarvestsMessage(settings, crop);
    }
    else {
        return SummaryTable_rankerProfitSummary(data, settings, timeNorm, matchValue);
    }
}

export const SummaryTable_Profit_tooltip = (data) => ((settings) => ((timeNorm) => ((profitSummary) => SummaryTable_profitTooltip(data, settings, timeNorm, profitSummary))));

export function SummaryTable_Profit_optimizer(data, settings, total, dateSpans) {
    return SummaryTable_optimizerProfitSummary(data, settings, total, map_1((dateSpan) => Optimizer_profitSummary(data, settings, dateSpan.Fertilizer, SummaryTable_mergeCropHarvests(dateSpan)), dateSpans));
}

export function SummaryTable_ROI_ranker(data, settings, timeNorm, fertilizer, crop) {
    const matchValue = Ranker_profitSummary(data, settings, timeNorm, fertilizer, crop);
    if (matchValue == null) {
        return noHarvestsMessage(settings, crop);
    }
    else {
        const summary = matchValue;
        const xs = [SummaryTable_rankerProfitSummary(data, settings, new TimeNormalization(0, []), summary), SummaryTable_roiSummary(settings, timeNorm, summary)];
        return react.createElement(react.Fragment, {}, ...xs);
    }
}

export function SummaryTable_ROI_tooltip(data, settings, timeNorm, summary) {
    const xs = [SummaryTable_profitTooltip(data, settings, new TimeNormalization(0, []), summary), SummaryTable_roiSummary(settings, timeNorm, summary)];
    return react.createElement(react.Fragment, {}, ...xs);
}

function SummaryTable_XP_verticalSummary(includeHarvests, timeNorm, xpSummary) {
    const summary = item_2(0, xpSummary.CropSummaries);
    const children = toList(delay(() => append(includeHarvests ? singleton(SummaryTable_keyValue("Harvests", summary.Harvests.toString())) : empty(), delay(() => append(singleton(SummaryTable_keyValue("XP", xp_3(summary.XpPerItem))), delay(() => append(singleton(SummaryTable_keyValue("Quantity", round2(summary.ItemQuantity))), delay(() => append(singleton(SummaryTable_keyValue("Total XP", xpFloat(round2(xpSummary.Xp)))), delay(() => singleton(SummaryTable_normalizationRows("XP", (arg) => xpFloat(round2(arg)), timeNorm, xpSummary.TimeNormalization, xpSummary.Xp))))))))))));
    return createElement("dl", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export function SummaryTable_XP_ranker(data, settings, timeNorm, fertilizer, crop) {
    const matchValue = Ranker_xpSummary(data, settings, timeNorm, fertilizer, crop);
    if (matchValue.tag === 1) {
        return invalidReasons(settings, crop, matchValue.fields[0]);
    }
    else {
        return SummaryTable_XP_verticalSummary(true, timeNorm, matchValue.fields[0]);
    }
}

export const SummaryTable_XP_tooltip = (timeNorm) => ((xpSummary) => SummaryTable_XP_verticalSummary(false, timeNorm, xpSummary));

function SummaryTable_XP_tableSummary(data, total, summaries) {
    let children_2, children, children_6, children_10, children_8;
    const children_12 = ofArray([(children_2 = singleton_1((children = ofArray([SummaryTable_thCol("Crop"), SummaryTable_thCol("Harvests"), SummaryTable_thCol("XP"), SummaryTable_thCol("Quantity"), SummaryTable_thCol("Total XP"), SummaryTable_thColWith(defaultOf())]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))), createElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    })), (children_6 = collect((xpSummary) => map_1((summary) => {
        const children_4 = ofArray([createElement("th", {
            scope: "row",
            children: createElement("span", {
                children: [fertilizerAndCrop(data, xpSummary.Fertilizer, summary.Crop)],
            }),
        }), createElement("td", {
            children: [summary.Harvests.toString()],
        }), createElement("td", {
            children: [xp_3(summary.XpPerItem)],
        }), createElement("td", {
            children: [round2(summary.ItemQuantity)],
        }), createElement("td", {
            children: [xpFloat(round2(CropXpSummaryModule_totalXp(summary)))],
        }), createElement("td", {})]);
        return createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_4)),
        });
    }, xpSummary.CropSummaries), summaries), createElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children_6)),
    })), (children_10 = singleton_1((children_8 = ofArray([createElement("th", {
        children: ["Total"],
    }), createElement("td", {}), createElement("td", {}), createElement("td", {}), createElement("td", {
        children: [xpFloat(round2(total))],
    }), createElement("td", {})]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children_8)),
    }))), createElement("tfoot", {
        children: reactApi.Children.toArray(Array.from(children_10)),
    }))]);
    return createElement("table", {
        children: reactApi.Children.toArray(Array.from(children_12)),
    });
}

export function SummaryTable_XP_optimizer(data, settings, total, dateSpans) {
    return SummaryTable_XP_tableSummary(data, total, map_1((dateSpan) => Optimizer_xpSummary(data, settings, dateSpan.Fertilizer, SummaryTable_mergeCropHarvests(dateSpan)), dateSpans));
}

export class PairData extends Record {
    constructor(Crops, Fertilizers, Pairs) {
        super();
        this.Crops = Crops;
        this.Fertilizers = Fertilizers;
        this.Pairs = Pairs;
    }
}

export function PairData_$reflection() {
    return record_type("StardewValleyStonks.WebApp.View.Visualization.PairData", [], PairData, () => [["Crops", array_type(Crop_$reflection())], ["Fertilizers", array_type(option_type(Fertilizer_$reflection()))], ["Pairs", array_type(tuple_type(tuple_type(uint32_type, option_type(string_type)), union_type("Microsoft.FSharp.Core.FSharpResult`2", [float64_type, enum_type("StardewValleyStonks.WebApp.Query.InvalidReasons", int32_type, [["None", 0], ["NotEnoughDays", 1], ["NoFertilizerPrice", 2], ["NotEnoughSeeds", 4], ["NoInvestment", 8], ["All", 15]])], FSharpResult$2, () => [[["ResultValue", float64_type]], [["ErrorValue", enum_type("StardewValleyStonks.WebApp.Query.InvalidReasons", int32_type, [["None", 0], ["NotEnoughDays", 1], ["NoFertilizerPrice", 2], ["NotEnoughSeeds", 4], ["NoInvestment", 8], ["All", 15]])]]])))]]);
}

function pairData(metric, timeNorm, data, settings) {
    const crops = Array.from(Selected_inSeasonCrops(data, settings));
    const fertilizers = Array.from(Selected_fertilizersOpt(data, settings));
    const rankValue = Ranker_rankValue(metric);
    return new PairData(crops, fertilizers, collect((crop) => {
        const profit = rankValue(data)(settings)(timeNorm)(crop);
        return map_1((fert) => [[CropModule_seed(crop), FertilizerModule_Opt_name(fert)], profit(fert)], fertilizers);
    }, crops));
}

function emptyPairData(pairData_1) {
    let elems;
    const noCrops = pairData_1.Crops.length === 0;
    const noFerts = pairData_1.Fertilizers.length === 0;
    return createElement("ul", createObj(ofArray([["className", join(" ", ["messages", "messages-large"])], (elems = toList(delay(() => append(noCrops ? singleton(createElement("li", {
        children: [Icon_warning("No crops selected.")],
    })) : empty(), delay(() => append(noFerts ? singleton(createElement("li", {
        children: [Icon_warning("No fertilizers selected.")],
    })) : empty(), delay(() => (!(noCrops ? true : noFerts) ? singleton(createElement("li", {
        children: [Icon_warning("No valid entries.")],
    })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function rankBy(label, metric, timeNorm, dispatchMetric, dispatchTimeNorm) {
    const children = ofArray([label, labeledHidden("Metric", options(3 + "em", getCaseName, map_1((x_1) => makeUnion(x_1, []), getUnionCases(RankMetric_$reflection())), metric, dispatchMetric)), labeledHidden("Time Normalization", options(6 + "em", getCaseName, map_1((x_3) => makeUnion(x_3, []), getUnionCases(TimeNormalization_$reflection())), timeNorm, dispatchTimeNorm))]);
    return createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

const Ranker_iconSize = round(Values_fontPx * 1.5);

const Ranker_iconGap = max_1(1, round(Values_fontPx * 0.25));

const Ranker_barGap = Ranker_iconGap;

function Ranker_pairImage(pairs, data, props) {
    let elements;
    const patternInput = item_2(props.payload.value, pairs);
    const item = CropModule_mainItem(getItemFromDict(data.Crops.fields[0], patternInput[0]));
    const xs_2 = [createElement("image", createObj(ofArray([["href", Icon_Path_item(item)], ["x", props.x - (Ranker_iconSize / 2)], ["y", props.y + Ranker_iconGap], ["width", Ranker_iconSize], ["height", Ranker_iconSize], (elements = singleton_1(createElement("title", {
        children: [getItemFromDict(data.Items.fields[0], item).Name],
    })), ["children", reactApi.Children.toArray(Array.from(elements))])]))), ofOption((fert_1) => {
        let elements_1;
        return createElement("image", createObj(ofArray([["href", Icon_Path_fertilizer(fert_1)], ["width", Ranker_iconSize], ["height", Ranker_iconSize], ["x", props.x - (Ranker_iconSize / 2)], ["y", (props.y + Ranker_iconSize) + (Ranker_iconGap * 2)], (elements_1 = singleton_1(createElement("title", {
            children: [fert_1],
        })), ["children", reactApi.Children.toArray(Array.from(elements_1))])])));
    }, patternInput[1])];
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function Ranker_harvestsText(harvests) {
    return createElement("span", {
        children: [` (${harvests} ${pluralizeTo(harvests, "harvest")})`],
    });
}

function Ranker_chartProfitTooltip(data, settings, timeNorm, roi, fertilizer, crop, profit) {
    const xs = toList(delay(() => {
        const matchValue = Ranker_profitSummary(data, settings, timeNorm, fertilizer, crop);
        if (matchValue == null) {
            const matchValue_2 = profit;
            if (matchValue_2.tag === 1) {
                return singleton(invalidReasons(settings, crop, matchValue_2.fields[0]));
            }
            else {
                return singleton(defaultOf());
            }
        }
        else {
            const profitSummary = matchValue;
            return append(singleton(Ranker_harvestsText(item_2(0, profitSummary.CropSummaries).Harvests)), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = profit, (matchValue_1.tag === 1) ? singleton(invalidReasons(settings, crop, matchValue_1.fields[0])) : (singleton(defaultOf()))), delay(() => (roi ? singleton(SummaryTable_ROI_tooltip(data, settings, timeNorm, profitSummary)) : singleton(SummaryTable_Profit_tooltip(data)(settings)(timeNorm)(profitSummary)))));
            }));
        }
    }));
    return react.createElement(react.Fragment, {}, ...xs);
}

function Ranker_chartXPTooltip(data, settings, timeNorm, fertilizer, crop) {
    const xs = toList(delay(() => {
        const matchValue = Ranker_xpSummary(data, settings, timeNorm, fertilizer, crop);
        if (matchValue.tag === 1) {
            return singleton(invalidReasons(settings, crop, matchValue.fields[0]));
        }
        else {
            const summary = matchValue.fields[0];
            return append(singleton(Ranker_harvestsText(item_2(0, summary.CropSummaries).Harvests)), delay(() => singleton(SummaryTable_XP_tooltip(timeNorm)(summary))));
        }
    }));
    return react.createElement(react.Fragment, {}, ...xs);
}

function Ranker_chartTooltip(pairs, data, settings, timeNorm, rankItem, props) {
    let elems, payload;
    const matchValue = props.payload;
    let matchResult, payload_1;
    if (matchValue != null) {
        if ((payload = matchValue, (payload.length > 0) && props.active)) {
            matchResult = 0;
            payload_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const patternInput = item_2(0, payload_1).payload;
            const patternInput_1 = item_2(patternInput[0], pairs);
            const crop = getItemFromDict(data.Crops.fields[0], patternInput_1[0]);
            const fertilizer_1 = map((key_2) => getItemFromDict(data.Fertilizers.fields[0], key_2), patternInput_1[1]);
            return createElement("div", createObj(ofArray([["id", "chart-tooltip"], (elems = toList(delay(() => append(singleton(createElement("h1", {
                children: [fertilizerAndCrop(data, fertilizer_1, crop)],
            })), delay(() => {
                const matchValue_1 = rankItem;
                switch (matchValue_1.tag) {
                    case 2:
                        return singleton(Ranker_chartXPTooltip(data, settings, timeNorm, fertilizer_1, crop));
                    default:
                        return singleton(Ranker_chartProfitTooltip(data, settings, timeNorm, equals(rankItem, new RankMetric(1, [])), fertilizer_1, crop, patternInput[1]));
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
        default:
            return defaultOf();
    }
}

function Ranker_svgRectPath(x, y, width, height) {
    return `M ${x},${y} h ${width} v ${height} h -${width} Z`;
}

function Ranker_barBackground(selectPair, props) {
    const x = props.x;
    const y = props.y;
    const width = props.width;
    const height = props.height;
    const i = props.payload[0] | 0;
    return createElement("path", {
        onClick: (_arg) => {
            selectPair(i);
        },
        x: x,
        y: y,
        width: width,
        height: height,
        d: Ranker_svgRectPath(x, y, width, height),
    });
}

function Ranker_errorBar(data, seedStrategy, metric, pairs, props) {
    const x = props.x;
    const y = props.y;
    const width = props.width;
    const height = props.height;
    const patternInput = props.payload;
    const value = patternInput[1];
    const patternInput_1 = item_2(patternInput[0], pairs);
    const seed = patternInput_1[0];
    const fert = patternInput_1[1];
    const cropDesc = CropModule_name((key) => getItemFromDict(data.Items.fields[0], key), getItemFromDict(data.Crops.fields[0], seed));
    const fertDesc = Option_defaultOrMap("", (fert_1) => (` with ${fert_1}`), fert);
    const valueDesc = Option_defaultOrMap("???", (value_1) => (`${round2(value_1 * (equals(metric, new RankMetric(1, [])) ? 100 : 1))}${RankMetricModule_unit(metric)}`), Option_ofResult(value));
    const xs_3 = toList(delay(() => append(singleton(createElement("title", {
        children: [`${cropDesc}${fertDesc}: ${valueDesc}`],
    })), delay(() => {
        let elements_1;
        const matchValue = value;
        if (matchValue.tag === 1) {
            const flags = matchValue.fields[0] | 0;
            const gap = width / 4;
            const maxHeight = (width * 3) + (gap * (3 - 1));
            const y_1 = props.background.height - maxHeight;
            return singleton(createElement("g", createObj(ofArray([["tabIndex", 0], ["onFocus", (value_17) => {
            }], (elements_1 = mapIndexed_1((i, tupledArg) => {
                let elements;
                return createElement("image", createObj(ofArray([["href", tupledArg[0]], ["x", x], ["y", y_1 + ((width + gap) * ((3 - 1) - i))], ["width", width], ["height", width], (elements = singleton_1(createElement("title", {
                    children: [tupledArg[1]],
                })), ["children", reactApi.Children.toArray(Array.from(elements))])])));
            }, toList(delay(() => append(((flags & 2) !== 0) ? singleton([Icon_Path_fertilizer(value_43(fert)), "No fertilizer price"]) : empty(), delay(() => append(((flags & 4) !== 0) ? singleton([Icon_Path_item(seed * 1), equals(seedStrategy, new SeedStrategy(0, [])) ? "No seed price" : "No seed source"]) : empty(), delay(() => append(((flags & 1) !== 0) ? singleton(["img/Time.webp", "No harvests possible"]) : empty(), delay(() => (((flags & 8) !== 0) ? singleton(["img/Gold.webp", "No investment"]) : empty())))))))))), ["children", reactApi.Children.toArray(Array.from(elements_1))])]))));
        }
        else {
            return singleton(createElement("path", {
                radius: 0,
                x: x,
                y: y,
                width: width,
                height: height,
                d: Ranker_svgRectPath(x, y, width, height),
                tabIndex: 0,
                onFocus: (value_14) => {
                },
            }));
        }
    }))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

function Ranker_chart(ranker, data, settings, pairs, dispatch) {
    let properties_5, right, elements, properties_1, properties_2, properties_3, properties_4;
    const patternInput = unzip(mapIndexed((i, tupledArg) => [tupledArg[0], [i, tupledArg[1]]], pairs));
    const pairs_1 = patternInput[0];
    const selectPair = (i_1) => {
        let matchValue;
        const patternInput_1 = item_2(i_1, pairs_1);
        const fert = patternInput_1[1];
        const crop = patternInput_1[0];
        dispatch(new RankerMessage(5, [(matchValue = ranker.RankItem, (matchValue.tag === 1) ? [crop, undefined] : ((matchValue.tag === 2) ? [undefined, some(fert)] : [crop, some(fert)]))]));
    };
    const properties_6 = ofArray([["debounce", 100], ["children", (properties_5 = ofArray([["data", patternInput[1]], ["barGap", Ranker_barGap], (right = (~~Values_fontPx * 2), ["margin", {
        top: defaultArg(0, 0),
        right: defaultArg(right, 0),
        left: defaultArg(0, 0),
        bottom: defaultArg(0, 0),
    }]), (elements = ofArray([reactApi_1.createElement(Tooltip, {
        content: (props) => Ranker_chartTooltip(pairs_1, data, settings, ranker.TimeNormalization, ranker.RankMetric, props),
    }), (properties_1 = ofArray([["dataKey", (arg) => Result_defaultValue(0, arg[1])], ["barSize", ~~round(Ranker_iconSize * 1.5)], ["onClick", (eventArgs) => {
        if ((eventArgs == null) ? true : objectHas(singleton_1("isTooltipActive"), eventArgs)) {
        }
        else {
            selectPair(eventArgs.payload[0]);
        }
    }], ["shape", (props_2) => Ranker_errorBar(data, settings.Profit.SeedStrategy, ranker.RankMetric, pairs_1, props_2)], ["activeBar", (props_3) => Ranker_errorBar(data, settings.Profit.SeedStrategy, ranker.RankMetric, pairs_1, props_3)], ["background", (props_4) => Ranker_barBackground(selectPair, props_4)]]), reactApi_1.createElement(Bar, createObj(properties_1))), (properties_2 = toList(delay(() => append(singleton(["unit", RankMetricModule_unit(ranker.RankMetric)]), delay(() => append(singleton(["domain", [0, "auto"]]), delay(() => append(singleton(["width", Values_fontPx * 5]), delay(() => append(singleton(["tickSize", Values_fontPx / 2]), delay(() => (equals(ranker.RankMetric, new RankMetric(1, [])) ? singleton(["tickFormatter", (x) => (x * 100)]) : empty()))))))))))), reactApi_1.createElement(YAxis, createObj(properties_2))), (properties_3 = ofArray([["dataKey", (tuple_2) => tuple_2[0]], ["tick", (props_5) => Ranker_pairImage(pairs_1, data, props_5)], ["interval", 0], ["height", ((Ranker_iconSize * 2) + (Ranker_iconGap * 3)) + 10], ["tickSize", 0]]), reactApi_1.createElement(XAxis, createObj(properties_3))), (properties_4 = ofArray([["startIndex", clampIndex(pairs_1, ~~ranker.BrushSpan[0])], ["endIndex", clampIndex(pairs_1, ~~ranker.BrushSpan[1])], ["height", ~~Values_fontPx * 2], ["travellerWidth", Values_fontPx / 2], ["onChange", (i_2) => {
        dispatch(new RankerMessage(4, [i_2.startIndex, i_2.endIndex]));
    }]]), reactApi_1.createElement(Brush, createObj(properties_4)))]), ["children", reactApi.Children.toArray(Array.from(elements))])]), reactApi_1.createElement(BarChart, createObj(properties_5)))]]);
    return reactApi_1.createElement(ResponsiveContainer, createObj(properties_6));
}

export function Ranker_ranker(ranker, data, settings, dispatch) {
    const pairData_1 = pairData(ranker.RankMetric, ranker.TimeNormalization, data, settings);
    let pairs;
    const matchValue = ranker.RankItem;
    pairs = ((matchValue.tag === 1) ? map_1((arg_2) => maxBy((arg_1) => Option_ofResult(arg_1[1]), arg_2[1], {
        Compare: compare,
    }), Array_groupBy((arg) => arg[0][0], pairData_1.Pairs, {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    })) : ((matchValue.tag === 2) ? map_1((arg_5) => maxBy((arg_4) => Option_ofResult(arg_4[1]), arg_5[1], {
        Compare: compare,
    }), Array_groupBy((arg_3) => arg_3[0][1], pairData_1.Pairs, {
        Equals: equals,
        GetHashCode: structuralHash,
    })) : pairData_1.Pairs));
    const pairs_1 = ranker.ShowInvalid ? pairs : pairs.filter((arg_6) => Result_isOk(arg_6[1]));
    pairs_1.sort((a, b) => {
        const matchValue_2 = b[1];
        const copyOfStruct = a[1];
        if (copyOfStruct.tag === 1) {
            const copyOfStruct_1 = matchValue_2;
            if (copyOfStruct_1.tag === 1) {
                return Enum_bitSetOrder(copyOfStruct.fields[0], copyOfStruct_1.fields[0]) | 0;
            }
            else {
                return 1;
            }
        }
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) {
                return -1;
            }
            else {
                return comparePrimitives(copyOfStruct_2.fields[0], copyOfStruct.fields[0]) | 0;
            }
        }
    });
    const xs_2 = toList(delay(() => {
        let elems, children_2, children;
        return append(singleton(createElement("div", createObj(ofArray([["id", "chart-controls"], (elems = [(children_2 = ofArray([(children = ofArray(["Rank", labeledHidden("Rank Item", options(5 + "em", getCaseName, map_1((x_5) => makeUnion(x_5, []), getUnionCases(RankItem_$reflection())), ranker.RankItem, (arg_7) => {
            dispatch(new RankerMessage(0, [arg_7]));
        }))]), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        })), rankBy("By", ranker.RankMetric, ranker.TimeNormalization, (arg_9) => {
            dispatch(new RankerMessage(1, [arg_9]));
        }, (arg_10) => {
            dispatch(new RankerMessage(2, [arg_10]));
        })]), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        })), checkbox("Show Invalid", ranker.ShowInvalid, (arg_11) => {
            dispatch(new RankerMessage(3, [arg_11]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => ((pairs_1.length === 0) ? singleton(emptyPairData(pairData_1)) : singleton(createElement("div", {
            id: "chart",
            children: Common_lazyView3((arg10$0040, pairs_2, dispatch_2) => Ranker_chart(ranker, data, settings, pairs_2, dispatch_2))(ranker.RankMetric)(pairs_1)(dispatch),
        })))));
    }));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function selectSpecificOrBest(name, length, toString, viewItem, items, selected, dispatch) {
    return labeledHidden(name, search(length, (_arg) => {
        let item;
        return (_arg.tag === 1) ? ((_arg.fields[0] == null) ? "???" : ((item = value_43(_arg.fields[0]), toString(item)))) : toString(_arg.fields[0]);
    }, (opt) => {
        const xs = toList(delay(() => ((opt.tag === 1) ? append(singleton(`Best ${name}: `), delay(() => singleton(Option_defaultOrMap("???", viewItem, opt.fields[0])))) : singleton(viewItem(opt.fields[0])))));
        return react.createElement(react.Fragment, {}, ...xs);
    }, items, selected, dispatch));
}

export function CropAndFertilizerSummary(props) {
    const app = props.App;
    const seed = props.Seed;
    const fertName = props.Fertilizer;
    const uiDispatch = props.Dispatch;
    const dispatch = (arg) => {
        props.Dispatch(new UIMessage(1, [arg]));
    };
    const selectDispatch = (arg_2) => {
        dispatch(new RankerMessage(5, [arg_2]));
    };
    const data = app.Data;
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    const ranker = ui.Ranker;
    const patternInput_1 = reactApi.useState([ranker.RankMetric, ranker.TimeNormalization]);
    const timeNorm = patternInput_1[0][1];
    const setState = patternInput_1[1];
    const metric = patternInput_1[0][0];
    const pairData_1 = pairData(metric, timeNorm, data, settings);
    let patternInput_4;
    const pairs = pairData_1.Pairs;
    let patternInput_3;
    if (pairs.length === 0) {
        patternInput_3 = [undefined, undefined];
    }
    else {
        const patternInput_2 = maxBy((arg_3) => Option_ofResult(arg_3[1]), pairs, {
            Compare: compare,
        })[0];
        patternInput_3 = [getItemFromDict(data.Crops.fields[0], patternInput_2[0]), some(map((key_2) => getItemFromDict(data.Fertilizers.fields[0], key_2), patternInput_2[1]))];
    }
    const metricValue = Ranker_rankValue(metric);
    patternInput_4 = [new FSharpChoice$2(1, [Option_defaultOrMap(patternInput_3[0], (fert_1) => {
        const fert_2 = map((key_5) => getItemFromDict(data.Fertilizers.fields[0], key_5), fert_1);
        if (pairData_1.Crops.length === 0) {
            return undefined;
        }
        else {
            return maxBy((crop_1) => Option_ofResult(metricValue(data)(settings)(timeNorm)(crop_1)(fert_2)), pairData_1.Crops, {
                Compare: compare,
            });
        }
    }, fertName)]), new FSharpChoice$2(1, [Option_defaultOrMap(patternInput_3[1], (seed_1) => {
        const crop_2 = getItemFromDict(data.Crops.fields[0], seed_1);
        if (pairData_1.Fertilizers.length === 0) {
            return undefined;
        }
        else {
            const profit = metricValue(data)(settings)(timeNorm)(crop_2);
            return some(maxBy((arg_4) => Option_ofResult(profit(arg_4)), pairData_1.Fertilizers, {
                Compare: compare,
            }));
        }
    }, seed)])];
    const bestFert_2 = patternInput_4[1];
    const bestCrop_2 = patternInput_4[0];
    const cropOptions = insertAt(0, bestCrop_2, map_1((Item_2) => (new FSharpChoice$2(0, [Item_2])), sortBy(Crops_sortKey(data), pairData_1.Crops, {
        Compare: comparePrimitives,
    })));
    const fertilizerOptions = insertAt(0, bestFert_2, map_1((arg_6) => (new FSharpChoice$2(0, [value_43(arg_6)])), sortBy((arg_5) => FertilizerModule_Opt_name(value_43(arg_5)), map_1(some, pairData_1.Fertilizers), {
        Compare: compare,
    })));
    const crop_3 = Option_defaultOrMap(bestCrop_2, (arg_7) => (new FSharpChoice$2(0, [getItemFromDict(data.Crops.fields[0], arg_7)])), seed);
    const fert_3 = Option_defaultOrMap(bestFert_2, (arg_8) => (new FSharpChoice$2(0, [map((key_13) => getItemFromDict(data.Fertilizers.fields[0], key_13), arg_8)])), fertName);
    const xs_2 = toList(delay(() => append(singleton(createElement("button", {
        className: "back",
        onClick: (_arg_13) => {
            dispatch(new RankerMessage(5, [undefined]));
        },
        children: "Back",
    })), delay(() => {
        let elems, children;
        return append(singleton(createElement("div", createObj(ofArray([["id", "summary-controls"], (elems = [(children = ofArray([selectSpecificOrBest("Crop", 12 + "em", (_arg_15) => CropModule_name((key_20) => getItemFromDict(data.Items.fields[0], key_20), _arg_15), (_arg_16) => Icon_crop(data, _arg_16), cropOptions, crop_3, (opt) => {
            selectDispatch([(opt.tag === 1) ? undefined : CropModule_seed(opt.fields[0]), fertName]);
        }), createElement("span", {
            children: [" with "],
        }), selectSpecificOrBest("Fertilizer", 15 + "em", Fertilizer_Opt_displayName, (_arg_17) => Option_defaultOrMap("No Fertilizer", Icon_fertilizer, _arg_17), fertilizerOptions, fert_3, (opt_1) => {
            selectDispatch([seed, (opt_1.tag === 1) ? undefined : some(FertilizerModule_Opt_name(opt_1.fields[0]))]);
        })]), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        })), rankBy(createElement("span", {
            children: ["Show"],
        }), metric, timeNorm, (metric_1) => {
            setState([metric_1, timeNorm]);
        }, (timeNorm_1) => {
            setState([metric, timeNorm_1]);
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let crop_5, fert_6;
            return (crop_3.tag === 1) ? ((crop_3.fields[0] != null) ? ((fert_3.tag === 1) ? ((fert_3.fields[0] != null) ? ((crop_5 = crop_3.fields[0], (fert_6 = value_43(fert_3.fields[0]), append(singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(11, []), "Summary", (metric.tag === 1) ? SummaryTable_ROI_ranker(data, settings, timeNorm, fert_6, crop_5) : ((metric.tag === 2) ? SummaryTable_XP_ranker(data, settings, timeNorm, fert_6, crop_5) : SummaryTable_Profit_ranker(data, settings, timeNorm, fert_6, crop_5)), uiDispatch)), delay(() => singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(10, []), "Growth Calendar", GrowthCalendar_ranker(data, settings, fert_6, crop_5), uiDispatch))))))) : singleton(emptyPairData(pairData_1))) : ((crop_5 = crop_3.fields[0], append(singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(11, []), "Summary", (metric.tag === 1) ? SummaryTable_ROI_ranker(data, settings, timeNorm, fert_3.fields[0], crop_5) : ((metric.tag === 2) ? SummaryTable_XP_ranker(data, settings, timeNorm, fert_3.fields[0], crop_5) : SummaryTable_Profit_ranker(data, settings, timeNorm, fert_3.fields[0], crop_5)), uiDispatch)), delay(() => singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(10, []), "Growth Calendar", GrowthCalendar_ranker(data, settings, fert_3.fields[0], crop_5), uiDispatch))))))) : singleton(emptyPairData(pairData_1))) : ((fert_3.tag === 1) ? ((fert_3.fields[0] != null) ? ((fert_6 = value_43(fert_3.fields[0]), append(singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(11, []), "Summary", (metric.tag === 1) ? SummaryTable_ROI_ranker(data, settings, timeNorm, fert_6, crop_3.fields[0]) : ((metric.tag === 2) ? SummaryTable_XP_ranker(data, settings, timeNorm, fert_6, crop_3.fields[0]) : SummaryTable_Profit_ranker(data, settings, timeNorm, fert_6, crop_3.fields[0])), uiDispatch)), delay(() => singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(10, []), "Growth Calendar", GrowthCalendar_ranker(data, settings, fert_6, crop_3.fields[0]), uiDispatch)))))) : singleton(emptyPairData(pairData_1))) : append(singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(11, []), "Summary", (metric.tag === 1) ? SummaryTable_ROI_ranker(data, settings, timeNorm, fert_3.fields[0], crop_3.fields[0]) : ((metric.tag === 2) ? SummaryTable_XP_ranker(data, settings, timeNorm, fert_3.fields[0], crop_3.fields[0]) : SummaryTable_Profit_ranker(data, settings, timeNorm, fert_3.fields[0], crop_3.fields[0])), uiDispatch)), delay(() => singleton(detailsSection(ui.OpenDetails, new OpenDetails_1(10, []), "Growth Calendar", GrowthCalendar_ranker(data, settings, fert_3.fields[0], crop_3.fields[0]), uiDispatch)))));
        }));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function rankerOrSummary(app, dispatch) {
    const patternInput = app.State;
    const ranker = patternInput[1].Ranker;
    const matchValue = ranker.SelectedCropAndFertilizer;
    if (matchValue == null) {
        return Common_lazyView3((ranker_1, tupledArg, dispatch_1) => Ranker_ranker(ranker_1, tupledArg[0], tupledArg[1], dispatch_1))(ranker)([app.Data, patternInput[0]])((arg) => {
            dispatch(new UIMessage(1, [arg]));
        });
    }
    else {
        return createElement(CropAndFertilizerSummary, {
            App: app,
            Dispatch: dispatch,
            Fertilizer: matchValue[1],
            Seed: unwrap(matchValue[0]),
        });
    }
}

export const patternInput$00401166 = createWorker();

const workerSubscribe = patternInput$00401166[1];

const workerQueue = patternInput$00401166[0];

function optimizerSummary(openDetails, data, settings, dispatch, objective, solution) {
    const xs_1 = toList(delay(() => {
        if (solution == null) {
            return singleton("Loading...");
        }
        else {
            const solution_1 = solution;
            return append(singleton(detailsSection(openDetails, new OpenDetails_1(13, []), "Summary", Common_lazyView((tupledArg) => {
                const _arg = tupledArg[1];
                const total = _arg[0];
                const dateSpans = _arg[1];
                return (tupledArg[0].tag === 1) ? SummaryTable_XP_optimizer(data, settings, total, dateSpans) : SummaryTable_Profit_optimizer(data, settings, total, dateSpans);
            })([objective, solution_1]), dispatch)), delay(() => singleton(detailsSection(openDetails, new OpenDetails_1(12, []), "Growth Calendar", Common_lazyView((dateSpans_1) => {
                let elems;
                return createElement("div", createObj(ofArray([["className", "calendar"], (elems = collect((dateSpan) => GrowthCalendar_optimizer(data, settings, dateSpan), dateSpans_1), ["children", reactApi.Children.toArray(Array.from(elems))])])));
            })(solution_1[1]), dispatch))));
        }
    }));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function Optimizer(props) {
    const data = props.Data;
    const settings = props.Settings;
    const objective = props.Objective;
    const patternInput = reactApi.useState([undefined, false]);
    const solution = patternInput[0][0];
    const setState = patternInput[1];
    reactApi.useEffect(() => {
        workerSubscribe((solution_1) => {
            setState([solution_1, false]);
        });
    }, []);
    const dependencies_2 = [data, settings, objective];
    reactApi.useEffect(() => {
        setState([solution, true]);
        workerQueue(data)(settings)(objective);
    }, dependencies_2);
    return createElement("div", createObj(toList(delay(() => append(patternInput[0][1] ? singleton(["className", "disabled"]) : empty(), delay(() => singleton(["children", optimizerSummary(props.OpenDetails, data, settings, props.Dispatch, objective, solution)])))))));
}

export function section(app, dispatch) {
    const patternInput = app.State;
    const ui = patternInput[1];
    const uiDispatch = (arg) => {
        dispatch(new StateMessage(1, [arg]));
    };
    return createElement("section", createObj(toList(delay(() => append(singleton(["id", "visualization"]), delay(() => append((equals(ui.Mode, new AppMode(0, [])) && (ui.Ranker.SelectedCropAndFertilizer == null)) ? singleton(["className", "visualization-chart"]) : empty(), delay(() => {
        let elems;
        return singleton((elems = [createElement(Tabs_1, {
            Current: ui.Mode,
            Dispatch: (arg_1) => {
                uiDispatch(new UIMessage(0, [arg_1]));
            },
            Label: "Visualization",
            Panel: (_arg) => {
                if (_arg.tag === 1) {
                    const xs = [labeled("Maximize", options(3 + "em", getCaseName, map_1((x_1) => makeUnion(x_1, []), getUnionCases(OptimizationObjective_$reflection())), ui.OptimizationObjective, (arg_2) => {
                        uiDispatch(new UIMessage(2, [arg_2]));
                    })), createElement(Optimizer, {
                        Data: app.Data,
                        Dispatch: (arg_4) => {
                            dispatch(new StateMessage(1, [arg_4]));
                        },
                        Objective: ui.OptimizationObjective,
                        OpenDetails: ui.OpenDetails,
                        Settings: patternInput[0],
                    })];
                    return react.createElement(react.Fragment, {}, ...xs);
                }
                else {
                    return rankerOrSummary(app, uiDispatch);
                }
            },
            Tabs: map_1((x_2) => makeUnion(x_2, []), getUnionCases(AppMode_$reflection())),
        })], ["children", reactApi.Children.toArray(Array.from(elems))]));
    }))))))));
}

//# sourceMappingURL=Visualization.js.map
